interface GTMDataLayer {
  userId: number;
  loginUserId: number;
  userEmail: string;
  userFullName: string;
  isImpersonating: boolean;
  revenueTierName: string;
  storesEnabled: string[];
  availableCarriers: string[];
  dateJoined: string;
  lifetimeVolSegmentMin: number;
  lifetimeVolSegmentMax: number;
  groupName: string; // This is fraud_status_id. Intentionally vaguely named to stop attackers from tampering.
  event?: string;
}

interface GTMAdditionalInformation {
  volumeSegment?: string; // TODO: Deprecate once min and max are being used
  volumeSegmentMin?: string;
  volumeSegmentMax?: string;
  primaryCarrier?: string;
}

function formatGTMAdditionalInformation(
  volumeSegment?: string,
  primaryCarrier?: string,
): GTMAdditionalInformation {
  const [min, max] = getVolumeMinAndMax(volumeSegment || '');

  return {
    primaryCarrier,
    volumeSegment,
    volumeSegmentMin: min,
    volumeSegmentMax: max,
  };
}

function getVolumeMinAndMax(volumeSegment: string): string[] {
  // volumeSegment has the form of "XX - YY", except for the last one which is "XXXX+"
  return volumeSegment.replace(/\s/g, '').split('-');
}

export {
  GTMDataLayer,
  GTMAdditionalInformation,
  formatGTMAdditionalInformation,
  getVolumeMinAndMax,
};
